import { l } from '@manychat/manyui'

import { ThreadStatus } from 'apps/chat/interfaces/statuses'
import { ChatMessageBlockType } from 'apps/chat/types/chatMessagesBlockList'
import { ChatMessageType } from 'apps/chat/types/chatMessageTypeList'

export const CUF_EMPTY_VALUE = 'unset'
export const LIKE_ID = 369239263222822
export const TEXT_REPLACER_MARK = '<replace>'
export const INSTAGRAM_REACTION_TYPE = 'ig_love'
export const MESSAGE_DATE_FORMAT = 'DD MMM YYYY, HH:mm'
export const AI_AUTOMATION_USER_NAME = 'ai_automation'

export const NO_RENDER_MESSAGE_TYPES = [
  ChatMessageBlockType.MSGOUT_SMS,
  ChatMessageBlockType.MSGOUT_MMS,
]

export const IN_TYPES = [
  ChatMessageType.CLICK_URL,
  ChatMessageType.CLICK_ACTION,
  ChatMessageType.MSGIN,
  ChatMessageType.MSGIN_SMS,
  ChatMessageType.MSGIN_WHATSAPP,
  ChatMessageType.MSGIN_INSTAGRAM,
  ChatMessageType.MSGIN_TELEGRAM,
  ChatMessageType.MSGIN_LC_TELEGRAM,
  ChatMessageType.MSGIN_TIKTOK,
]

export const NOTE_TYPES = [
  ChatMessageType.USER_THREAD_NOTE,
  ChatMessageType.USER_THREAD_NOTE_INSTAGRAM,
  ChatMessageType.USER_THREAD_NOTE_SMS,
  ChatMessageType.USER_THREAD_NOTE_TELEGRAM,
  ChatMessageType.USER_THREAD_NOTE_WHATSAPP,
  ChatMessageType.USER_THREAD_NOTE_TIKTOK,
]

export const META_TYPES = [
  ChatMessageType.TAG_ADDED,
  ChatMessageType.TAG_REMOVED,
  ChatMessageType.SEQ_ADDED,
  ChatMessageType.SEQ_REMOVED,
  ChatMessageBlockType.SEQ_PAUSED,
  ChatMessageBlockType.SEQ_RESUME,
  ChatMessageType.WIDGET_ADDED,
  ChatMessageType.USER_CUF_SET,
  ChatMessageType.USER_CUF_UNSET,
  ChatMessageType.USER_SUF_PHONE_CHANGE,
  ChatMessageType.USER_SUF_EMAIL_CHANGE,
  ChatMessageType.USER_SUF_FIRST_NAME_CHANGE,
  ChatMessageType.USER_SUF_LAST_NAME_CHANGE,
  ChatMessageType.CLICK_BUY,
  ChatMessageType.USER_ORDER_PAID,
  ChatMessageType.USER_RULE_TRIGGERED,
  ChatMessageType.USER_SMART_DELAY_SCHEDULED,
  ChatMessageType.USER_SUBSCRIBED,
  ChatMessageType.USER_UNSUBSCRIBED,
  ChatMessageType.USER_TT_SUBSCRIBED,
  ChatMessageType.USER_TT_UNSUBSCRIBED,
  ChatMessageType.USER_FB_UNSUBSCRIBED,
  ChatMessageType.USER_IG_UNSUBSCRIBED,
  ChatMessageType.USER_WA_UNSUBSCRIBED,
  ChatMessageType.USER_SMS_UNSUBSCRIBED,
  ChatMessageType.USER_TG_UNSUBSCRIBED,
  ChatMessageType.USER_SEQUENCE_MESSAGE_SCHEDULED,
  ChatMessageType.USER_SEQUENCE_MESSAGE_RESCHEDULED,
  ChatMessageType.FLOW_SEND_FROM_LC,
  ChatMessageType.MSGOUT_EMAIL,
  ChatMessageType.MSGOUT_SMS,
  ChatMessageType.MSGOUT_KEYWORD_SMS,
  ChatMessageType.CUSTOM_EVENT_TRIGGERED,
  ChatMessageType.MSGOUT_MMS,
  ChatMessageType.NOTIFY_ADMIN_LC,
  ChatMessageType.FACEBOOK_GUEST_CHAT_STARTED,
  ChatMessageType.FACEBOOK_GUEST_CHAT_ENDED,
  ChatMessageType.GUEST_LINK,
  ChatMessageType.VISITOR_LINKED,
  ChatMessageType.CGT_TRIGGER_COMMENT,
  ChatMessageType.IG_CGT_TRIGGER_COMMENT,
  ChatMessageType.USER_MERGED,
  ChatMessageType.ASSIGN,
  ChatMessageType.REASSIGN,
  ChatMessageType.UNASSIGN,
  ChatMessageType.USER_THREAD_NEW,
  ChatMessageType.USER_THREAD_CLOSED,
  ChatMessageType.USER_THREAD_OPENED,
  ChatMessageType.RECURRING_NOTIFICATION_TOKEN_STOPPED,
  ChatMessageType.RECURRING_NOTIFICATION_TOKEN_RESUMED,
  ChatMessageType.IG_RECURRING_NOTIFICATION_TOKEN_STOPPED,
  ChatMessageType.IG_RECURRING_NOTIFICATION_TOKEN_RESUMED,
  ChatMessageType.BASIC_AUTO_ASSIGN,
  ChatMessageType.FLOW_BASED_ASSIGN,
  ChatMessageType.RULE_BASED_AUTO_ASSIGN,
  ChatMessageType.SCHEDULED_MESSAGE_WAS_NOT_SENT,
  ChatMessageType.CLICK_URL,
  ChatMessageType.WA_REQUEST_WELCOME,
  ChatMessageType.WA_TIKTOK_ADS_EVENT_SENT,
  ChatMessageType.FB_TIKTOK_ADS_EVENT_SENT,
  ChatMessageBlockType.TIKTOK_ADS_CTX_TRIGGER_FB,
  ChatMessageBlockType.TIKTOK_ADS_CTX_TRIGGER_WA,
  ChatMessageType.TIKTOK_REFERRAL,
  ChatMessageType.TIKTOK_USERNAME_CHANGED,
  ChatMessageType.TIKTOK_DISPLAY_NAME_CHANGED,
  ChatMessageBlockType.FB_TIKTOK_ADS_REFERRAL,
  ChatMessageBlockType.WA_TIKTOK_ADS_REFERRAL,
  ChatMessageBlockType.AI_INTENT_TRIGGER_INSTAGRAM,
  ChatMessageBlockType.AI_INTENT_TRIGGER_FACEBOOK,
  ChatMessageBlockType.AI_INTENT_TRIGGER_WHATSAPP,
  ChatMessageBlockType.AI_INTENT_TRIGGER_TIKTOK,
  ChatMessageBlockType.AI_INTENT_TRIGGER_TELEGRAM,
  ChatMessageBlockType.AI_AUTOMATION_INSTAGRAM_TRIGGERED,
  ChatMessageBlockType.TIKTOK_CTX_TRIGGER,
]

export enum SEND_ENTITY {
  REPLY = 'reply',
  NOTE = 'note',
}

export const META_CAPTIONS = {
  [ChatMessageBlockType.CGT_TRIGGER_COMMENT]: l.makeTranslate('New Comment'),
  [ChatMessageBlockType.IG_CGT_TRIGGER_COMMENT]: l.makeTranslate('New Comment'),
  [ChatMessageBlockType.FB_TIKTOK_ADS_EVENT_SENT]: l.makeTranslate('TikTok Ads event'),
  [ChatMessageBlockType.WA_TIKTOK_ADS_EVENT_SENT]: l.makeTranslate('TikTok Ads event'),
  [ChatMessageBlockType.TAG_ADDED]: l.makeTranslate('Tag added'),
  [ChatMessageBlockType.TAG_REMOVED]: l.makeTranslate('Tag removed'),
  [ChatMessageBlockType.SEQ_ADDED]: l.makeTranslate('Subscribed to sequence'),
  [ChatMessageBlockType.SEQ_REMOVED]: l.makeTranslate('Unsubscribed from sequence'),
  [ChatMessageBlockType.SEQ_PAUSED]: l.makeTranslate(
    '<l10n context="automation or user has paused"/>has paused automated replies in this conversation forever, you can edit the pause or resume the automation anytime',
  ),
  [ChatMessageBlockType.SEQ_PAUSED_TEMPORARILY]: l.makeTranslate(
    '<l10n context="automation or user has paused"/>has paused automated replies in this conversation temporarily, you can edit the pause or resume the automation anytime',
  ),
  [ChatMessageBlockType.SEQ_RESUME]: l.makeTranslate('Automations have been resumed'),
  [ChatMessageBlockType.WIDGET_ADDED]: l.makeTranslate('Opted-in through widget'),
  [ChatMessageBlockType.USER_CUF_SET]: l.makeTranslate('Custom field changed'),
  [ChatMessageBlockType.USER_CUF_UNSET]: l.makeTranslate('Custom field cleared'),
  [ChatMessageBlockType.USER_SUF_EMAIL_CHANGE]: l.makeTranslate('Email system field changed'),
  [ChatMessageBlockType.USER_SUF_PHONE_CHANGE]: l.makeTranslate('Phone system field changed'),
  [ChatMessageBlockType.USER_SUF_FIRST_NAME_CHANGE]: l.makeTranslate(
    '<l10n context="user who made the change"/>updated contact’s first name',
  ),
  [ChatMessageBlockType.USER_SUF_LAST_NAME_CHANGE]: l.makeTranslate(
    '<l10n context="user who made the change"/>updated contact’s last name',
  ),
  [ChatMessageBlockType.CLICK_BUY]: l.makeTranslate('Buy button clicked'),
  [ChatMessageBlockType.USER_ORDER_PAID]: l.makeTranslate('Contact order paid'),
  [ChatMessageBlockType.USER_RULE_TRIGGERED]: l.makeTranslate('Rule triggered'),
  [ChatMessageBlockType.USER_SMART_DELAY_SCHEDULED]: l.makeTranslate(
    'Smart delay started in the Automation',
  ),
  [ChatMessageBlockType.USER_SUBSCRIBED]: l.makeTranslate('Contact was subscribed'),
  [ChatMessageBlockType.USER_UNSUBSCRIBED]: l.makeTranslate('Contact was unsubscribed by'),
  [ChatMessageBlockType.USER_FB_UNSUBSCRIBED]: l.makeTranslate(
    'Contact was unsubscribed from Facebook channel by',
  ),
  [ChatMessageBlockType.USER_IG_UNSUBSCRIBED]: l.makeTranslate(
    'Contact was unsubscribed from Instagram channel by',
  ),
  [ChatMessageBlockType.USER_WA_UNSUBSCRIBED]: l.makeTranslate(
    'Contact was unsubscribed from WhatsApp channel by',
  ),
  [ChatMessageBlockType.USER_TG_UNSUBSCRIBED]: l.makeTranslate(
    'Contact was unsubscribed from Telegram channel by',
  ),
  [ChatMessageBlockType.USER_TT_SUBSCRIBED]: l.makeTranslate(
    'Contact was subscribed to TikTok channel by',
  ),
  [ChatMessageBlockType.USER_TT_UNSUBSCRIBED]: l.makeTranslate(
    'Contact was unsubscribed from TikTok channel by',
  ),
  [ChatMessageBlockType.USER_SMS_UNSUBSCRIBED]: l.makeTranslate(
    'Contact was unsubscribed from SMS channel by',
  ),
  [ChatMessageBlockType.USER_SEQUENCE_MESSAGE_SCHEDULED]: l.makeTranslate(
    'New message from sequence',
  ),
  [ChatMessageBlockType.USER_SEQUENCE_MESSAGE_RESCHEDULED]:
    l.makeTranslate('Message from sequence'),
  [ChatMessageBlockType.FLOW_SEND_FROM_LC]: l.makeTranslate('Automation sent via Live Chat'),
  [ChatMessageBlockType.MSGOUT_EMAIL]: l.makeTranslate('Email message sent'),
  [ChatMessageBlockType.MSGOUT_SMS]: l.makeTranslate('SMS message sent'),
  [ChatMessageBlockType.MSGOUT_KEYWORD_SMS]: l.makeTranslate('SMS keyword sent'),
  [ChatMessageBlockType.CUSTOM_EVENT_TRIGGERED]: l.makeTranslate('Event triggered'),
  [ChatMessageBlockType.MSGOUT_MMS]: l.makeTranslate('MMS message sent'),
  [ChatMessageBlockType.NOTIFY_ADMIN_LC]: l.makeTranslate('Notify Admin'),
  [ChatMessageBlockType.FACEBOOK_GUEST_CHAT_STARTED]: l.makeTranslate(
    'This visitor conversation will be deactivated after 24 hours',
  ),
  [ChatMessageBlockType.FACEBOOK_GUEST_CHAT_ENDED]: l.makeTranslate(
    'Visitor ended this conversation',
  ),
  [ChatMessageBlockType.USER_MERGED]: l.makeTranslate('Contact was merged with other'),
  [ChatMessageBlockType.ASSIGN]: l.makeTranslate('Conversation was assigned to'),
  [ChatMessageBlockType.REASSIGN]: l.makeTranslate('Conversation reassigned from'),
  [ChatMessageBlockType.UNASSIGN]: l.makeTranslate('Conversation was unassigned from'),
  [ChatMessageBlockType.USER_THREAD_CLOSED]: l.makeTranslate('Conversation was moved'),
  [ChatMessageBlockType.USER_THREAD_NEW]: l.makeTranslate('Conversation was moved'),
  [ChatMessageBlockType.USER_THREAD_OPENED]: l.makeTranslate('Conversation was moved'),
  [ChatMessageBlockType.FB_TIKTOK_ADS_REFERRAL]: l.makeTranslate(
    'Contact was referred by TikTok ad',
  ),
  [ChatMessageBlockType.TIKTOK_AD_REFERRAL]: l.makeTranslate('Contact was referred by TikTok ad'),
  [ChatMessageBlockType.WA_TIKTOK_ADS_REFERRAL]: l.makeTranslate(
    'Contact was referred by TikTok ad',
  ),
  [ChatMessageBlockType.WA_REQUEST_WELCOME]: l.makeTranslate(
    'Customer opened chat for the first time via WhatsApp link',
  ),
  [ChatMessageBlockType.TIKTOK_USERNAME_CHANGED]: l.makeTranslate('Username system field changed'),
  [ChatMessageBlockType.TIKTOK_DISPLAY_NAME_CHANGED]: l.makeTranslate('Name system field changed'),
  [ChatMessageBlockType.SHARE_POST]: l.makeTranslate('Shared post'),
  [ChatMessageBlockType.AI_AUTOMATION_INSTAGRAM_TRIGGERED]: l.makeTranslate(
    'AI started the conversation',
  ),
  [ChatMessageBlockType.FOLLOW_REPLY_IG_FOLLOWED]: l.makeTranslate(
    'User subscribed to your account',
  ),
}

export const STATUS_FILTER_FROM_LABELS: Record<ThreadStatus, ReturnType<typeof l.makeTranslate>> = {
  [ThreadStatus.OPENED]: l.makeTranslate('Open'),
  [ThreadStatus.CLOSED]: l.makeTranslate('Closed'),
  [ThreadStatus.NEW]: l.makeTranslate('Unassigned'),
}

export const STATUS_FILTER_TO_LABELS = {
  [ChatMessageBlockType.USER_THREAD_NEW]: l.makeTranslate('Unassigned'),
  [ChatMessageBlockType.USER_THREAD_OPENED]: l.makeTranslate('Open'),
  [ChatMessageBlockType.USER_THREAD_CLOSED]: l.makeTranslate('Closed'),
}
